import {
  Grid,
  Box,
  IconButton,
  Typography,
  SvgIcon,
  useTheme,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import { tokens } from "../../theme";
import CustomButton from "../../components/CustomButton.jsx";
import Badge from "@mui/material/Badge";
import Popover from "@mui/material/Popover";

import {
  collapseMenu,
  isAuthPageAtom,
  showErrorAlertDialog,
  triggerFileDownload,
} from "../../config/AppConfig";
import { useAtom } from "jotai";
import { useLocation, useNavigate } from "react-router-dom";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import DebugLog from "../../utils/DebugLog";
import * as CONSTANT from "../../constants/Constant";
import {
  ALREADY_DOWNLOADED_FILES,
  AWAITING_FILE_DOWNLOAD,
  FAILED_DOWNLOADED_FILES,
  LOGIN_RESPONSE,
  MESSAGE_KEY,
  SESSION_ID,
  USER_NAME,
} from "../../constants/LocalStorageKeyValuePairString.jsx";
import {
  getFromLocalStorage,
  getFromLocalStorageJsonObject,
  saveToLocalStorageJsonObject,
} from "../../utils/localStorageUtils.js";
import ToolbarFilterButton from "../../components/ToolbarFilterButton.jsx";
import { LOGIN } from "../../constants/Constant.jsx";

import Backdrop from "@mui/material/Backdrop";
import LinearProgress from "@mui/material/LinearProgress";
import Divider from "@mui/material/Divider";
import {
  ALERT,
  ERROR,
  ERROR_WHILE_FETCHING_DATA,
  PROCESSING_PLEASE_WAIT,
} from "../../constants/Strings.jsx";
import useAxiosHookForDownloadReportInitiate from "../../hooks/UseAxiosForReportDownloadInititate.jsx";
import { initializeEncryption } from "../../services/AesGcmEncryption.jsx";
import { ApiErrorCode, ApiType } from "../../services/ApiTags.jsx";
import NoDataFound from "../../components/NoDataFound.jsx";
import { isEmptyArray } from "formik";

const Topbar = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [loggedInUserName, setLoggedInUserName] = useState("");
  const [isAuthPage, setAuthStatus] = useAtom(isAuthPageAtom);
  const [isCollapsed, setIsCollapsed] = useAtom(collapseMenu);

  const navigate = useNavigate();
  const [isSmallScreen, setIsSmallScreen] = useState(false);
  const [filter, setFilter] = useState("");

  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState(ALERT);
  const [content, setContent] = useState("");
  const [, setError] = useState("");
  const [getDialogStatus, setErrorDialog] = useAtom(showErrorAlertDialog);
  const [getProgressbarText, setProgressbarText] = useState("");
  const [triggerDownload, setInititateFileDownloadTrigger] =
    useAtom(triggerFileDownload);
  const {
    downloadedDataFromInitiateApi,
    downloadInitiateApiError,
    showProgressBarForDownloadInitiate,
    fetchDataFromDownloadInitiate,
  } = useAxiosHookForDownloadReportInitiate();

  const [inProgresslist, setInProgressList] = useState([]);
  const [failedlist, setFailedList] = useState([]);
  const [completedlist, setCompletedList] = useState([]);
  const location = useLocation();
  //const { authDetails } = useContext(AuthContext);

  useEffect(() => {
    const userDetails = getFromLocalStorageJsonObject(LOGIN_RESPONSE);
    let adjustments = [];
    let incentive = [];
    let cashOutLimit = [];
    let reports = [];
    const pathName = location.pathname
    const sessionId = getFromLocalStorage(SESSION_ID);
    const pathAfterFirstSlash = location.pathname
    .split("/")
    .slice(1)
    .join("/");
    if(pathAfterFirstSlash==="*" || pathAfterFirstSlash==="" || pathAfterFirstSlash==="resetForgotPassword"){
         DebugLog("pathAfterFirstSlash >>"+pathAfterFirstSlash)
    }
   else if (sessionId === "" || sessionId === undefined || sessionId === null) {
      if (
        pathAfterFirstSlash !== "ForgotPassword" &&
        pathAfterFirstSlash !== "forgotUsername" &&
        pathAfterFirstSlash !== "SignIn" &&
        pathAfterFirstSlash !== "resetForgotPassword" && 
        pathAfterFirstSlash !== "changePassword" &&
        pathAfterFirstSlash !== ""
      ) {
        navigate("/");
        return;
      }
    } else if (userDetails!==null && userDetails!==undefined && !isEmptyArray(userDetails)) {
      let menuListSize = userDetails.length;
      if (menuListSize != null && menuListSize > 0) {
        userDetails.forEach((item, index) => {
          if (item.menuListName === "Adjustment") {
            adjustments = [...item.menuItem];
          }

          if (item.menuListName === "Incentive") {
            incentive = [...item.menuItem];
          }

          if (item.menuListName === "Cash Out Limit") {
            cashOutLimit = [...item.menuItem];
          }

          if (item.menuListName === "Reports") {
            reports = [...item.menuItem];
          }
        });
      }

      if (
        isEmptyArray(adjustments) &&
        isEmptyArray(incentive) &&
        isEmptyArray(cashOutLimit) &&
        !isEmptyArray(reports)
      ) {
        if (
          pathName === CONSTANT.REPORTS_FILTER_ROUTE ||
          pathName === CONSTANT.FINANCE_DASHBOARD ||
          pathName === CONSTANT.CHANGE_PASSWORD_ROUTE ||
          pathName === CONSTANT.SEARCH_AND_SELECT_COMPANY_DETAILS_ROUTE 
        ) {
          DebugLog("pathName111 >>"+pathName)
        } else {
          navigate("*");
        }
      }

     else if (isEmptyArray(adjustments) && !isEmptyArray(incentive) && !isEmptyArray(cashOutLimit)) {
        if (
          pathName === CONSTANT.REPORTS_FILTER_ROUTE ||
          pathName === CONSTANT.FINANCE_DASHBOARD  ||
          pathName === CONSTANT.PAYOUT_ARCHIVE_ROUTE ||
          pathName === CONSTANT.VALIDATION_ROUTE ||
          pathName === CONSTANT.PAYOUT_DEALER_SUMMARY_ROUTE ||
          pathName === CONSTANT.PAYOUT_ROUTE ||
          pathName === CONSTANT.ON_HOLD_ROUTE ||
          pathName === CONSTANT.EXCLUSION_ROUTE ||
          pathName === CONSTANT.PAYOUT_DATES_ROUTE ||
          pathName === CONSTANT.WITHOLDING_TAX_ROUTE ||
          pathName === CONSTANT.REPORTS_ROUTE ||
          pathName === CONSTANT.PAYOUT_TRANSACTION_DETAILS ||
          pathName === CONSTANT.PAYOUT_ALL_TRANSACTION_DETAILS ||
          pathName === CONSTANT.PAYOUT_DEALER_BREAKDOWN ||
          pathName === CONSTANT.ON_HOLD_DETAILS_ROUTE ||
          pathName === CONSTANT.ON_HOLD_DEALERS_ROUTE ||
          pathName === CONSTANT.ON_HOLD_ALL_TRANSACTIONS_DETAILS ||
          pathName === CONSTANT.SUCCESS_ROUTE ||
          pathName === CONSTANT.ON_HOLD_ACTION_ITEM_SUCCESS_ROUTE ||
          pathName === CONSTANT.PAYOUTS_ACTION_ITEMS_SUCCESS_ROUTE ||
          pathName === CONSTANT.ADD_EXCLUSION_DEALER_ROUTE ||
          pathName === CONSTANT.PAYOUTS_ACTION_ITEMS_SUCCESS_ROUTE ||
          pathName === CONSTANT.REMOVED_EXCLUSION_TRANSACTION_TYPE_ROUTE ||
          pathName === CONSTANT.REMOVED_EXCLUSION_TRANSACTION_DETAILS_ROUTE ||
          pathName === CONSTANT.REMOVED_EXCLUSION_TRANSACTIONS_ROUTE ||
          pathName === CONSTANT.ON_HOLD_PAYOUT_CYCLE_ROUTE ||
          pathName === CONSTANT.CHANGE_PASSWORD_ROUTE ||
          pathName === CONSTANT.CASHOUT_LIMITS_ROUTE  ||
          pathName === CONSTANT.SEARCH_AND_SELECT_COMPANY_DETAILS_ROUTE ||
         pathName === CONSTANT.CREATE_ROLES_ROUTE
        ) {
          DebugLog("pathName2222 >>"+pathName)
        } else {
          navigate("*");
        }
      } else if (isEmptyArray(adjustments) && !isEmptyArray(incentive) && isEmptyArray(cashOutLimit)) {
        if (
          pathName === CONSTANT.REPORTS_FILTER_ROUTE ||
          pathName === CONSTANT.FINANCE_DASHBOARD  ||
          pathName === CONSTANT.PAYOUT_ARCHIVE_ROUTE ||
          pathName === CONSTANT.VALIDATION_ROUTE ||
          pathName === CONSTANT.PAYOUT_DEALER_SUMMARY_ROUTE ||
          pathName === CONSTANT.PAYOUT_ROUTE ||
          pathName === CONSTANT.ON_HOLD_ROUTE ||
          pathName === CONSTANT.EXCLUSION_ROUTE ||
          pathName === CONSTANT.PAYOUT_DATES_ROUTE ||
          pathName === CONSTANT.WITHOLDING_TAX_ROUTE ||
          pathName === CONSTANT.REPORTS_ROUTE ||
          pathName === CONSTANT.PAYOUT_TRANSACTION_DETAILS ||
          pathName === CONSTANT.PAYOUT_ALL_TRANSACTION_DETAILS ||
          pathName === CONSTANT.PAYOUT_DEALER_BREAKDOWN ||
          pathName === CONSTANT.ON_HOLD_DETAILS_ROUTE ||
          pathName === CONSTANT.ON_HOLD_DEALERS_ROUTE ||
          pathName === CONSTANT.ON_HOLD_ALL_TRANSACTIONS_DETAILS ||
          pathName === CONSTANT.SUCCESS_ROUTE ||
          pathName === CONSTANT.ON_HOLD_ACTION_ITEM_SUCCESS_ROUTE ||
          pathName === CONSTANT.PAYOUTS_ACTION_ITEMS_SUCCESS_ROUTE ||
          pathName === CONSTANT.ADD_EXCLUSION_DEALER_ROUTE ||
          pathName === CONSTANT.PAYOUTS_ACTION_ITEMS_SUCCESS_ROUTE ||
          pathName === CONSTANT.REMOVED_EXCLUSION_TRANSACTION_TYPE_ROUTE ||
          pathName === CONSTANT.REMOVED_EXCLUSION_TRANSACTION_DETAILS_ROUTE ||
          pathName === CONSTANT.REMOVED_EXCLUSION_TRANSACTIONS_ROUTE ||
          pathName === CONSTANT.ON_HOLD_PAYOUT_CYCLE_ROUTE ||
          pathName === CONSTANT.CHANGE_PASSWORD_ROUTE ||
          pathName === CONSTANT.SEARCH_AND_SELECT_COMPANY_DETAILS_ROUTE 
        ) {
          DebugLog("pathName3333 >>"+pathName)
        } else {
          navigate("*");
        }
      }  else if (!isEmptyArray(adjustments) && !isEmptyArray(incentive) && !isEmptyArray(cashOutLimit)) {
        if (
          pathName === CONSTANT.REPORTS_FILTER_ROUTE ||
          pathName === CONSTANT.FINANCE_DASHBOARD  ||
          pathName === CONSTANT.PAYOUT_ARCHIVE_ROUTE ||
          pathName === CONSTANT.VALIDATION_ROUTE ||
          pathName === CONSTANT.PAYOUT_DEALER_SUMMARY_ROUTE ||
          pathName === CONSTANT.PAYOUT_ROUTE ||
          pathName === CONSTANT.ON_HOLD_ROUTE ||
          pathName === CONSTANT.EXCLUSION_ROUTE ||
          pathName === CONSTANT.PAYOUT_DATES_ROUTE ||
          pathName === CONSTANT.WITHOLDING_TAX_ROUTE ||
          pathName === CONSTANT.REPORTS_ROUTE ||
          pathName === CONSTANT.PAYOUT_TRANSACTION_DETAILS ||
          pathName === CONSTANT.PAYOUT_ALL_TRANSACTION_DETAILS ||
          pathName === CONSTANT.PAYOUT_DEALER_BREAKDOWN ||
          pathName === CONSTANT.ON_HOLD_DETAILS_ROUTE ||
          pathName === CONSTANT.ON_HOLD_DEALERS_ROUTE ||
          pathName === CONSTANT.ON_HOLD_ALL_TRANSACTIONS_DETAILS ||
          pathName === CONSTANT.SUCCESS_ROUTE ||
          pathName === CONSTANT.ON_HOLD_ACTION_ITEM_SUCCESS_ROUTE ||
          pathName === CONSTANT.PAYOUTS_ACTION_ITEMS_SUCCESS_ROUTE ||
          pathName === CONSTANT.ADD_EXCLUSION_DEALER_ROUTE ||
          pathName === CONSTANT.PAYOUTS_ACTION_ITEMS_SUCCESS_ROUTE ||
          pathName === CONSTANT.REMOVED_EXCLUSION_TRANSACTION_TYPE_ROUTE ||
          pathName === CONSTANT.REMOVED_EXCLUSION_TRANSACTION_DETAILS_ROUTE ||
          pathName === CONSTANT.REMOVED_EXCLUSION_TRANSACTIONS_ROUTE ||
          pathName === CONSTANT.ON_HOLD_PAYOUT_CYCLE_ROUTE ||
          pathName === CONSTANT.CHANGE_PASSWORD_ROUTE ||
          pathName === CONSTANT.CASHOUT_LIMITS_ROUTE ||
          pathName === CONSTANT.CANCEL_ADJUSTMENT_SUCCESS_ROUTE ||
          pathName === CONSTANT.SEARCH_DEALER_CREDIT_DEBIT_ROUTE ||
          pathName === CONSTANT.ADD_ADJUSTMENTS_ROUTE ||
          pathName === CONSTANT.UNFREEZE_FREEZE_DEALER_ROUTE ||
          pathName === CONSTANT.ADD_DEALER_ROUTE ||
          pathName === CONSTANT.CREDIT_DEBIT_ROUTE ||
          pathName === CONSTANT.FREEZE_ACCOUNT_ROUTE ||
          pathName === CONSTANT.SEARCH_AND_SELECT_COMPANY_DETAILS_ROUTE ||
          pathName === CONSTANT.ADJUSTMENT_ROUTE ||
          pathName === CONSTANT.EARMARK_ROUTE  ||
          pathName === CONSTANT.SEARCH_AND_SELECT_COMPANY_DETAILS_ROUTE ||
          pathName === CONSTANT.CLUSTER_LISTING_ROUTE||
          pathName === CONSTANT.ROLES_ROUTE||
          pathName === CONSTANT.USERS_ROUTE||
          pathName === CONSTANT.HIERARCHY_ROUTE||
          pathName === CONSTANT.MODULES_ROUTE||
          pathName === CONSTANT.REQUEST_ROUTE||
          pathName === CONSTANT.LOG_ROUTE||
          pathName === CONSTANT.LOG_DETAILS_ROUTE||
          pathName === CONSTANT.CREATE_CLUSTER_ROUTE||
          pathName === CONSTANT.CLUSTER_DETAILS_ROUTE||
          pathName === CONSTANT.REQUEST_DETAILS_ROUTE||
          pathName === CONSTANT.MODULES_UPDATE_SUCCESS_ROUTE||
          pathName === CONSTANT.CREATE_ROLES_ROUTE
        ) {
          DebugLog("pathName444 >>"+pathName)
        } else {
          navigate("*");
        }
      }
    }
  });

  useEffect(() => {
    saveToLocalStorageJsonObject(ALREADY_DOWNLOADED_FILES, completedlist);
  }, [completedlist]);

  useEffect(() => {
    saveToLocalStorageJsonObject(AWAITING_FILE_DOWNLOAD, inProgresslist);
  }, [inProgresslist]);

  useEffect(() => {
    saveToLocalStorageJsonObject(FAILED_DOWNLOADED_FILES, failedlist);
  }, [failedlist]);

  const handleDownload = (filePath) => {
    window.open(filePath, "_blank");
  };

  useEffect(() => {
    const intervalFunction = () => {
      activateTrigger();
    };

    // Set up the interval to call the function every 30 seconds
    const intervalId = setInterval(intervalFunction, 30000);

    // Clean up the interval on unmount
    return () => clearInterval(intervalId);
  }, []); // Empty dependency array ensures this runs only once on mount

  useEffect(() => {
    activateTrigger();
  }, []);

  useEffect(() => {
    activateTrigger();
  }, [triggerDownload]);

  function activateTrigger() {
    try {
      // if (triggerDownload) {
      const alreadyAwaitingDownloadFiles = getFromLocalStorageJsonObject(
        AWAITING_FILE_DOWNLOAD
      );
      if (
        alreadyAwaitingDownloadFiles !== null &&
        alreadyAwaitingDownloadFiles !== undefined
      ) {
        setInProgressList(alreadyAwaitingDownloadFiles);
      }

      const failedDownLoadFiles = getFromLocalStorageJsonObject(
        FAILED_DOWNLOADED_FILES
      );
      if (failedDownLoadFiles !== null && failedDownLoadFiles !== undefined) {
        setFailedList(failedDownLoadFiles);
      }

      if (
        alreadyAwaitingDownloadFiles !== null &&
        alreadyAwaitingDownloadFiles.length > 0
      ) {
        for (let i = 0; i < alreadyAwaitingDownloadFiles.length; i++) {
          checkReportDownloadStatus(
            alreadyAwaitingDownloadFiles[i].fileReferenceToken,
            alreadyAwaitingDownloadFiles[i].reportName
          );
        }
      }
    } catch (error) {
      DebugLog("Error >>>>>>" + error);
    }
  }

  useEffect(() => {
    getLoggedInUserName();
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 1000); // Adjust the width threshold as needed

      if (isSmallScreen) {
        setIsCollapsed(true);
      } else {
        setIsCollapsed(false);
      }
    };

    // Add event listener for window resize
    window.addEventListener("resize", handleResize);

    // Call handleResize initially to set the initial state
    handleResize();

    // Cleanup by removing the event listener when component unmounts
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [isSmallScreen, isAuthPage]); // Empty dependency array ensures that this effect runs only once on component mount

  function checkReportDownloadStatus(token, reportName) {
    try {
      const requestObject = {
        referenceToken: token,
      };

      initializeEncryption(
        requestObject,
        getFromLocalStorage(MESSAGE_KEY),
        ApiType.REPORT_READY_TO_DOWNLOAD
      ).then((encryptedContentData) => {
        fetchDataFromDownloadInitiate(
          process.env.REACT_APP_REPORT_DOWNLOAD_READY_API_URL,
          ApiType.REPORT_READY_TO_DOWNLOAD,
          ApiType.POST_METHOD,
          encryptedContentData,
          {},
          (data) => {
            if (data !== null) {
              const alreadyAwaitingDownloadFiles =
                getFromLocalStorageJsonObject(AWAITING_FILE_DOWNLOAD);
              setInProgressList(alreadyAwaitingDownloadFiles);

              const downLoadCompletedFiles = getFromLocalStorageJsonObject(
                ALREADY_DOWNLOADED_FILES
              );
              if (
                downLoadCompletedFiles !== null &&
                downLoadCompletedFiles !== undefined
              ) {
                setCompletedList(downLoadCompletedFiles);
              }

              const failedDownLoadFiles = getFromLocalStorageJsonObject(
                FAILED_DOWNLOADED_FILES
              );
              if (
                failedDownLoadFiles !== null &&
                failedDownLoadFiles !== undefined
              ) {
                setFailedList(failedDownLoadFiles);
              }

              if (data.result.fileGenerationStatus === "COMPLETED") {
                for (let i = 0; i < alreadyAwaitingDownloadFiles.length; i++) {
                  const model = alreadyAwaitingDownloadFiles[i];
                  if (model.referenceToken === data.result.referenceToke) {
                    // setInProgressList(prevList => {
                    //   const newList = [...prevList];
                    //   newList[i] = newItem;
                    //   return newList;
                    // });

                    const fileDownloadSuccess = {
                      reportName: alreadyAwaitingDownloadFiles[i].reportName,
                      fileReferenceToken: data.result.fileReferenceToken,
                      fileGenerationStatus: data.result.fileGenerationStatus,
                      fileDownloadPath: data.result.fileDownloadPath,
                    };
                    setCompletedList((prevList) => [
                      ...prevList,
                      fileDownloadSuccess,
                    ]);

                    setInProgressList((prevList) => {
                      const newList = [...prevList];
                      newList.splice(i, 1);
                      return newList;
                    });
                  }
                }

                window.open(data.result.fileDownloadPath, "_blank");
              } else if (data.result.fileGenerationStatus === "FAILED") {
                for (let i = 0; i < alreadyAwaitingDownloadFiles.length; i++) {
                  const model = alreadyAwaitingDownloadFiles[i];
                  if (model.referenceToken === data.result.referenceToke) {
                    // setInProgressList(prevList => {
                    //   const newList = [...prevList];
                    //   newList[i] = newItem;
                    //   return newList;
                    // });

                    const fileDownloadFailed = {
                      reportName: alreadyAwaitingDownloadFiles[i].reportName,
                      fileReferenceToken: data.result.fileReferenceToken,
                      fileGenerationStatus: data.result.fileGenerationStatus,
                      fileDownloadPath: data.result.fileDownloadPath,
                    };

                    setFailedList((prevList) => [
                      ...prevList,
                      fileDownloadFailed,
                    ]);

                    setInProgressList((prevList) => {
                      const newList = [...prevList];
                      newList.splice(i, 1);
                      return newList;
                    });
                  }
                }
              }
            }
          }
        );
      });
    } catch (error) {
      const message = error.response != null ? error.response : error.message;
      showErrorAlert(
        error.message,
        ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
      );
    }
  }
  function showErrorAlert(title, content) {
    try {
      setError();
      setLoading(false);

      setTitle(title);
      setContent(content);
      setErrorDialog(true);
    } catch (error) {
      DebugLog(error);
    }
  }
  useEffect(() => {
    if (showProgressBarForDownloadInitiate) {
      setProgressbarText(PROCESSING_PLEASE_WAIT);
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [showProgressBarForDownloadInitiate]);

  useEffect(() => {
    if (downloadInitiateApiError) {
      if (
        downloadInitiateApiError.message !== null &&
        downloadInitiateApiError.message !== undefined &&
        downloadInitiateApiError.message === ApiErrorCode.NETWORK_ERROR
      ) {
        showErrorAlert(ERROR, downloadInitiateApiError.message);
      } else if (
        downloadInitiateApiError.data.errorCode === ApiErrorCode.SESSION_EXPIRED
      ) {
        alert(downloadInitiateApiError.data.displayErrorMessage);
        navigate(LOGIN);
      } else {
        const message =
          downloadInitiateApiError.data !== null &&
          downloadInitiateApiError.data.displayErrorMessage !== null
            ? downloadInitiateApiError.data.displayErrorMessage
            : downloadInitiateApiError.message;
        showErrorAlert(
          ERROR,
          ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
        );
      }
    }
  }, [downloadInitiateApiError]);

  const handleFilterChange = (filter) => {
    setFilter(filter);
    if (filter === "Logout") {
      goToLoginPage();
    }
    if (filter === "Change Password") {
      navigate("/ChangePassword");
    }
  };
  function goToLoginPage() {
    setAuthStatus(true);
    navigate("/");
  }

  function getLoggedInUserName() {
    if (
      getFromLocalStorage(USER_NAME) != "" &&
      getFromLocalStorage(USER_NAME) != null
    ) {
      setLoggedInUserName(getFromLocalStorage(USER_NAME));
    }
  }

  function openSlidingBar() {
    document.getElementById("sidebar").style.visibility = "visible";
    document.getElementById("switcher").style.display = "flex";
    document.getElementById("sidebar").style.zIndex = "10000";

    if ((document.getElementById("sidebar").style.visibility = "visible")) {
      document.getElementById("switcher").onclick = function () {
        setIsCollapsed(true);
        document.getElementById("sidebar").style.visibility = "hidden";
        document.getElementById("switcher").style.display = "none";
      };
    } else if (
      (document.getElementById("sidebar").style.visibility = "hidden")
    ) {
      document.getElementById("switcher").onclick = function () {
        setIsCollapsed(true);
        document
          .getElementsByClassName("pro-sidebar")
          .className.add("collapsed");
        document.getElementById("sidebar").style.visibility = "visible";
        document.getElementById("switcher").style.display = "none";
      };
    } else {
      document.getElementById("sidebar").style.visibility = "visible";
      document.getElementById("switcher").style.display = "none";
    }
  }

  const getInitials = (name) => {
    // check if name is null or empty
    if (!name) return "";

    const words = name.split(" ");
    const initials = words
      .slice(0, 2)
      .map((word) => word[0])
      .join("")
      .toUpperCase();
    return initials;
  };

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handlePopover = (event) => {
    setAnchorEl(event.currentTarget);
    activateTrigger();
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <div>
      {!isAuthPage ? (
        <Box display="flex" justifyContent="flex-end" p={2} pb={0}>
          <Box
            display={{ xs: "flex", sm: "none" }}
            backgroundColor="#fff"
            borderRadius={"20px"}
            justifyContent={"flex-start"}
            sx={{
              position: "absolute",
              left: "20px",
              color: colors.grey[200],
            }}
          >
            {/* <IconButton onClick={colorMode.toggleColorMode}>
          {theme.palette.mode === "dark" ? (
            <DarkModeOutlinedIcon />
          ) : (
            <LightModeOutlinedIcon />
          )}
        </IconButton> */}
            {/* 
<button type="button" className="sidebar-toggler" onClick={() => toggleSidebar() }>
                <img src={ iconsImgs.menu } alt="" />
            </button> */}

            <IconButton className="openMenu" onClick={() => openSlidingBar()}>
              <MenuOutlinedIcon />
            </IconButton>
          </Box>

          {/* SEARCH BAR */}
          <Box
            display="flex"
            backgroundColor={colors.grey[900]}
            borderRadius="20px"
            mr={1}
            sx={{
              "& .MuiButton-icon.MuiButton-startIcon ": {
                margin: "0 !important",
              },
            }}
          >
            {/*<InputBase
              sx={{ ml: 2, flex: 1 }}
              placeholder="Search"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            /> */}
            <Badge badgeContent={inProgresslist.length} color="primary">
              <IconButton
                type="button"
                sx={{ p: 1 }}
                onClick={handlePopover}
                style={{ boxShadow: "0px 12px 24px 0px rgba(0, 0, 0, 0.08)" }}
              >
                <SvgIcon>
                  <svg
                    width="24"
                    height="25"
                    viewBox="0 0 24 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M18.0697 15.1152L11.9997 21.1852L5.92969 15.1152"
                      stroke="#292D32"
                      stroke-width="1.5"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M12 4.18506V21.0151"
                      stroke="#292D32"
                      stroke-width="1.5"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </SvgIcon>
              </IconButton>
            </Badge>

            {/* <Badge badgeContent={1} color="primary">
            <CustomButton
              btnBG={colors.grey[900]}
              btnColor={colors.grey[100]}
              onClick={handlePopover}
              aria-describedby={id}
              
              btnStartIcon={
                <SvgIcon>
                <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M18.0697 15.1152L11.9997 21.1852L5.92969 15.1152" stroke="#292D32" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M12 4.18506V21.0151" stroke="#292D32" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </SvgIcon>
              }
            >
            </CustomButton>
            </Badge> */}
          </Box>
          <Box mr={1}>
            <ToolbarFilterButton
              name={getInitials(loggedInUserName)}
              options={["Change Password", "Logout"]}
              defaultOption="Option 1"
              onChange={handleFilterChange}
              versionLabel="v0.0.4"
            />
          </Box>

          <Backdrop
            sx={{
              background: "rgba(232, 233, 237, 0.5)",
              color: "#fff",
              zIndex: (theme) => theme.zIndex.drawer + 1,
            }}
            open={open}
            onClick={handleClose}
          >
            <Popover
              id={id}
              open={open}
              sx={{
                "& .MuiPopover-paper": {
                  boxShadow: "0px 12px 24px 0px rgba(0, 0, 0, 0.08)",
                  borderRadius: "12px",
                  marginTop: "10px",
                  width: "24rem",
                },
              }}
              anchorEl={anchorEl}
              onClose={handleClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
            >
              {inProgresslist.length === 0 && completedlist.length === 0
                ? NoDataFound()
                : ""}
              <Grid container p={2} spacing={1} direction={"column"}>
                {inProgresslist.map((item, index) => (
                  <Grid container p={3} spacing={3} direction={"column"}>
                    <Grid item>
                      <Typography
                        sx={{
                          fontWeight: "bold",
                          fontSize: "22px",
                          marginBottom: "6px",
                        }}
                      >
                        Preparing File
                      </Typography>
                      <Typography variant="paragraph" color={"#888888"}>
                        Please Wait
                      </Typography>
                    </Grid>
                    <Grid item>
                      <Typography
                        variant="h6"
                        sx={{
                          fontWeight: "bold",
                          fontSize: "14px",
                          marginBottom: "6px",
                        }}
                      >
                        {item.reportName + ".xlsx"}
                      </Typography>
                      <Box sx={{ width: "100%" }}>
                        <LinearProgress />
                      </Box>
                    </Grid>

                    <Grid item>
                      <Divider />
                      <Divider variant="fullWidth"></Divider>
                    </Grid>
                  </Grid>
                ))}

                {failedlist.map((item, index) => (
                  <Grid container spacing={1} direction={"column"} p={2}>
                    <Grid item>
                      <Grid
                        container
                        direction={"row"}
                        alignItems={"center"}
                        spacing={1.5}
                      >
                        {/* <Grid item>
                      <SvgIcon sx={{ width: "38px", height: "auto" }}>
                        <svg
                          width="48"
                          height="48"
                          viewBox="0 0 48 48"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle cx="24" cy="24" r="24" fill="#FF0084" />
                          <path
                            d="M17.3535 23.7222L22.0612 28.4299L30.9227 19.5684"
                            stroke="white"
                            stroke-width="2.95385"
                            stroke-linecap="round"
                          />
                        </svg>
                      </SvgIcon>
                    </Grid> */}

                        <Grid item>
                          <Typography
                            sx={{ fontWeight: "bold", fontSize: "22px" }}
                          >
                            Failed
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item>
                      <Typography
                        variant="h6"
                        sx={{ fontWeight: "bold", fontSize: "14px" }}
                      >
                        {item.reportName + ".xlsx"}
                      </Typography>
                    </Grid>
                  </Grid>
                ))}

                {completedlist.map((item, index) => (
                  <Grid container spacing={1} direction={"column"} p={2}>
                    <Grid item>
                      <Grid
                        container
                        direction={"row"}
                        alignItems={"center"}
                        spacing={1.5}
                      >
                        <Grid item>
                          <SvgIcon sx={{ width: "38px", height: "auto" }}>
                            <svg
                              width="48"
                              height="48"
                              viewBox="0 0 48 48"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <circle cx="24" cy="24" r="24" fill="#FF0084" />
                              <path
                                d="M17.3535 23.7222L22.0612 28.4299L30.9227 19.5684"
                                stroke="white"
                                stroke-width="2.95385"
                                stroke-linecap="round"
                              />
                            </svg>
                          </SvgIcon>
                        </Grid>

                        <Grid item>
                          <Typography
                            sx={{ fontWeight: "bold", fontSize: "22px" }}
                          >
                            Completed
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item>
                      <Typography
                        variant="h6"
                        sx={{ fontWeight: "bold", fontSize: "14px" }}
                      >
                        {item.reportName + ".xlsx"}
                      </Typography>
                    </Grid>
                    {/* <RoundIconButton onClick={handleDownload}>
      <GetAppIcon />
    </RoundIconButton> */}
                    <Box mt={2}>
                      <CustomButton
                        btnBG={colors.grey[900]}
                        btnColor={colors.grey[100]}
                        aria-describedby={id}
                        btnStartIcon={
                          <img
                            src="../../assets/common/Download.svg"
                            width={22}
                          />
                        }
                        btnTxt={"Download"}
                        onClick={() => handleDownload(item.fileDownloadPath)}
                      ></CustomButton>
                    </Box>
                    {/* <Grid item>
                <Typography variant="h6" sx={{ fontWeight:"bold", fontSize:"14px" }}>Device Reimbursement ( 22nd )</Typography>
              </Grid> */}
                  </Grid>
                ))}

                {/* <Grid item>
                <CustomButton
                btnBG={colors.grey[900]}
                btnColor={colors.grey[100]}
                onClick={handlePopover}
                aria-describedby={id}
                btnTxt={"Clear List"}
              >
              </CustomButton>
              </Grid> */}
              </Grid>
            </Popover>
          </Backdrop>

          {/* ICONS */}
          {/* <Box display="flex" backgroundColor="#fff" borderRadius={"20px"}>
            <IconButton onClick={colorMode.toggleColorMode}>
              {theme.palette.mode === "dark" ? (
                <DarkModeOutlinedIcon />
              ) : (
                <LightModeOutlinedIcon />
              )}
            </IconButton>

            <IconButton onClick={() => openSlidingBar()}>
              <NotificationsOutlinedIcon />
            </IconButton>

            <IconButton onClick={() => goToLoginPage()}>
              <LogoutOutlined />
            </IconButton>
          </Box> */}
        </Box>
      ) : (
        ""
      )}
    </div>
  );
};

export default Topbar;
